import { actionTypes } from '../constants/actionTypes';

const initialState = {
  locations: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.locationRelated.GET_LOCATIONS_SUCCESS:
      return {
        ...state,
        locations: action.response
      };
    default:
      return state;
  }
};
